/**
 * Датапикер для браузеров, которые не поддерживают input type="date"
 * TODO: переписать нормально
 */

var isDateSupported = function () {
    var input = document.createElement('input');
    var value = 'a';
    input.setAttribute('type', 'date');
    input.setAttribute('value', value);
    return (input.value !== value);
};


if (!isDateSupported()) {
    document.querySelectorAll('.js-datepicker').forEach(input => {
        const lang = document.getElementsByTagName('html')[0].getAttribute('lang');

        const picker = datepicker(input, {
            customDays: lang === 'ru' ? ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'] : null,
            customMonths: lang === 'ru' ? ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'] : null,
            formatter: (inp, date) => {
                /**
                 * Приводим дату к формату "2020-09-31"
                 */
                const y = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
                const m = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
                const d = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);

                inp.value = `${y}-${m}-${d}`;
            }
        });

        picker.onSelect = () => {
            /**
            * Временный костыль для фильтра
            */
            input.closest('.js-filter').querySelectorAll('[type="submit"]').forEach(btn => btn.disabled = false);

            /**
             * Ещё один костыль T_T
             * закрываем пикер
             */
            setTimeout(() => {
                try {
                    input.closest('.js-input-date').querySelector('.qs-datepicker-container').classList.add('qs-hidden');
                } catch (error) {
                    console.log(error);
                }
            }, 0);
        };


        /**
         * Задаём минимальное и максимальное значения
         */
        const min = input.getAttribute('min').split(/\s*\-\s*/g);
        picker.setMin(new Date(min[0], min[1], min[2]));

        const max = input.getAttribute('max').split(/\s*\-\s*/g);
        picker.setMax(new Date(max[0], max[1], max[2]));


        /**
         * Задаём класс родителю
         */
        try {
            input.closest('.js-input-date').classList.add('_is-datepicker');
        } catch (error) {
            console.log(error);
        }
    });
};



// WEBPACK FOOTER //
// ./_src/js/Datepicker.js